export { computeFloorplanStats } from "@shared/floorplanStats";
export type { FloorplanAutoStats } from "@shared/floorplanStats";

/**
 * Returns true if a statement belongs to the given lender, checking:
 *   1. Explicit lenderId link
 *   2. Extracted lenderName (exact, case-insensitive)
 *   3. File name contains the lender's name (catches "Unknown Lender" PDFs
 *      uploaded under a lender's name, e.g. "Kinetic.pdf" → Kinetic lender)
 */
export function statementMatchesLender(
  s: any,
  lender: { id: string; name: string }
): boolean {
  if (s.lenderId === lender.id) return true;
  const nameNorm = lender.name.toLowerCase().trim();
  if (!s.lenderId && s.lenderName?.toLowerCase().trim() === nameNorm) return true;
  if (!s.lenderId && s.fileName?.toLowerCase().includes(nameNorm)) return true;
  return false;
}

/**
 * Returns the most-recent statement for each currently active lender
 * (matched by ID, name, or filename). Statements that do not correspond
 * to a known active lender are excluded from portfolio totals.
 */
export function filterStatementsToLenders(
  statements: any[],
  lenders: Array<{ id: string; name: string }>
): any[] {
  const out: any[] = [];

  // Match each known lender to its most-recent statement
  for (const lender of lenders) {
    const pool = statements.filter((s) => statementMatchesLender(s, lender));
    if (!pool.length) continue;
    const sorted = [...pool].sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
    out.push(sorted[0]);
  }

  return out;
}
